module.exports = __webpack_public_path__ + "media/common/images/cta/sanjid-38bded07d10c4df5633eda64675191fa.jpeg";